<template>
    <div>
        <create-recommendation-card />
        <recommendation-list-table />
    </div>
</template>

<script>
import CreateRecommendationCard from '../../components/rec-table/CreateRecommendationCard'
import RecommendationListTable from '../../components/rec-table/RecommendationListTable'

export default {
    name: 'RecommendationTableView',
    components: {
        'create-recommendation-card': CreateRecommendationCard,
        'recommendation-list-table': RecommendationListTable,
    },
}
</script>

<style scoped></style>
